import { j as H } from "./jsx-runtime-3tyXYecC.mjs";
import { forwardRef as h } from "react";
import { m as c } from "./tss-DN0acMKN.mjs";
import { T as d, M as g, d as u } from "./constants-CnFYFetN.mjs";
import { T as r } from "./Typography-DfkimCSn.mjs";
const T = c()(({ mode: l, typography: i, themeName: e, palette: t }) => ({
  h1: {
    fontFamily: i.h1.fontFamily,
    fontSize: i.h1.fontSize,
    lineHeight: i.h1.lineHeight
  },
  h2: {
    fontFamily: i.h2.fontFamily,
    fontSize: i.h2.fontSize,
    lineHeight: i.h2.lineHeight
  },
  h3: {
    fontFamily: i.h3.fontFamily,
    fontSize: i.h3.fontSize,
    lineHeight: i.h3.lineHeight
  },
  h4: {
    fontFamily: i.h4.fontFamily,
    fontSize: i.h4.fontSize,
    lineHeight: i.h4.lineHeight
  },
  h5: {
    fontFamily: i.h5.fontFamily,
    fontSize: i.h5.fontSize,
    lineHeight: i.h5.lineHeight
  },
  h6: {
    fontFamily: i.h6.fontFamily,
    fontSize: i.h6.fontSize,
    lineHeight: i.h6.lineHeight
  },
  biggie: {
    fontFamily: i.biggie.fontFamily,
    fontSize: i.biggie.fontSize,
    lineHeight: i.biggie.lineHeight
  },
  large: {
    fontFamily: i.large.fontFamily,
    fontSize: i.large.fontSize,
    lineHeight: i.large.lineHeight
  },
  medium: {
    fontFamily: i.medium.fontFamily,
    fontSize: i.medium.fontSize,
    lineHeight: i.medium.lineHeight
  },
  root: {
    color: e === d.Encore ? t.grey[900] : void 0,
    "&&": {
      color: l === g.Dye ? u.main : void 0
    }
  },
  small: {
    fontFamily: i.small.fontFamily,
    fontSize: i.small.fontSize,
    lineHeight: i.small.lineHeight
  },
  teenie: {
    fontFamily: i.teenie.fontFamily,
    fontSize: i.teenie.fontSize,
    lineHeight: i.teenie.lineHeight
  }
}));
function m(l, i) {
  const { classes: e, cx: t } = T(), f = ["biggie", "large", "medium", "small", "teenie"], { variant: n, className: s, color: a, sx: S, ...z } = l, F = n ? e[n] : e.medium;
  let o = n;
  return f.includes(n) && (o = void 0), /* @__PURE__ */ H.jsx(
    r,
    {
      className: t(s, F, e.root),
      ref: i,
      sx: { color: a, ...S },
      variant: o,
      ...z,
      "data-fabric-component": "Typography"
    }
  );
}
m.displayName = "Typography";
const C = h(m);
export {
  C as T
};
//# sourceMappingURL=typography-Bj_iezxf.mjs.map
